import { Checkbox, DataSourceMode, Layout, Overlay, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutSelectStopsPrompt } from "./autogen/AutogenLayoutSelectStopsPrompt";

export class SelectStopsPrompt extends AutogenLayoutSelectStopsPrompt {
    static async showDialog(stopRows: ModelRow<any>[], onStopRevert: (stopRow: ModelRow) => void): Promise<boolean | null> {
        return new Promise((resolve,reject) => {
            const layout = Layout.getLayout("lme/dispatch/SelectStopsPrompt") as SelectStopsPrompt;
            const overlay = Overlay.showInOverlay(layout, { closeOnClickOff: false, greyedBackground: true, centered: true });
            layout.addLayoutLoadListener(() => {
                layout.tableSelectStops.dataSource.setRowsAndMode(DataSourceMode.UPDATE,
                    [new ModelRow(layout.mainDataSource.url, true, { stop_type: "Select All Stops" }), ...stopRows]);
                layout.buttonClose.addClickListener(() => dialogCancelled());
                layout.buttonCancel.addClickListener(() => dialogCancelled());
                layout.buttonRevert.addClickListener(() => dialogOnRevert());
            })

            const dialogCancelled = () => {
                Overlay.hideOverlay(overlay);
                resolve(null);
            }

            const dialogOnRevert = () => {
                layout.tableSelectStops.rows.forEach((row: TableRow) => {
                    const modelRow = row.data as ModelRow;
                    const checked = (row.findComponentById("checkboxStop") as Checkbox)?.checked;
                    if (checked && !modelRow._appending && modelRow.originalData!= null) {
                        modelRow.revertToOriginalData();
                        onStopRevert(modelRow);
                    }
                });
                Overlay.hideOverlay(overlay);
                resolve(true);
            }
        });
    }

    /** This is an event handler for the onRowDisplay event of tableSelectStops. */
    tableSelectStopsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const panelStopNumber = tableRow.findComponentById("panelStopNumber");
        panelStopNumber.visible = !modelRow._appending;
    }

    /** This is an event handler for the onChange event of checkboxStop. */
    checkboxStopOnChange(event) {
        const row: ModelRow = event.target.boundRow;
        if (!row._appending) return;
        this.tableSelectStops.rows.forEach(row => {
            const checkbox = row.findComponentById("checkboxStop") as Checkbox;
            checkbox.checked = event.newValue && checkbox.enabled;
        });
    }
}
